'use client'

import { useApolloClient } from '@apollo/client'
import { getOperationName } from '@apollo/client/utilities'
import { ProductListPriceAndStockDocument } from '@gql-generated/graphql'
import { useCallback } from 'react'

const ProductList_PriceAndStockOperationName = getOperationName(ProductListPriceAndStockDocument)

export function useRefreshProductListPriceAndStock() {
  const client = useApolloClient()

  return useCallback(() => {
    if (!ProductList_PriceAndStockOperationName) {
      console.error('Failed to refetch query ProductList_PriceAndStock')
    } else {
      client.refetchQueries({
        include: [ProductList_PriceAndStockOperationName],
      })
    }
  }, [client])
}
